<template>
  <div class="my-card" >
    <!-- swiper -->
    <swiper :options="swiperOption" v-if="ExList && ExList.length > 0" ref="swiper">
      <swiperSlide v-for="(card, index) in ExList" :key="'card' + index" data-index="index" >
        <div class="my-card-link" @click="linkToCom(card,index)" >
            <img :src="card.logo" alt="" v-if="card.logo"> 
            <img src="@/assets/img/empty.png" alt="" v-else>
            <!-- <img src="@/assets/img/empty.png"/> -->
        </div>
      </swiperSlide> 
    </swiper>
    <div class="no-msg" v-else>
        暂无数据!
    </div>
    <!-- <div class="card-msg" v-if="selectEX">
      <div class="card-msg-li">
        <div class="card-msg-com">
          <div class="card-msg-logo">
            <img v-if="selectEX.logo" :src="selectEX.logo" alt="">
            <img v-else src="@/assets/img/empty.png" alt="">
          </div>
          <p class="name" v-if="selectEX.compName">{{selectEX.compName}}</p>
          <p class="num">发布<span> {{selectEX.releaseList.totalCount}} </span>个商机</p>
          <p class="msg" v-if="selectEX.summary">{{selectEX.summary}}</p>
        </div>
        <div class="card-msg-needs" v-if="selectEX.releaseList && selectEX.releaseList.items && selectEX.releaseList.items.length > 0" v-for="(item,index) in selectEX.releaseList.items" :key="index">
          <div class="one-bot">
            <p>
                <span class="time">{{item.inTime | moment('YYYY/MM/DD')}}</span>
                <span class="view" v-if="item.viewCount">
                  <i class="icon iconfont icon-zhiboguankanshu"></i>
                  {{item.viewCount > 9999 ? (Math.floor(item.viewCount/1000)/10) + 'W' :item.viewCount}}
                </span>
            </p>
            <h3>{{item.information.length > 58 ? item.information.slice(0,58) + '...' : item.information}}</h3>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "swiperCard",
  data() {
    const that = this;
    return { 
      ExList:[],
      selectEX:null,
      swiperActive:0,
      swiperIndex:0,
      swiperOption: {
        slidesPerView: 9,
        autoplay: true,
        // loop : true,
        initialSlide : 0, 
        height:120,
        centeredSlides : true,
        // slidesOffsetBefore:-530,
        // centeredSlidesBounds: true,
        on: {
          slideChangeTransitionEnd: function(){
            this.swiperActive = this.realIndex;
            that.selectEX = that.ExList[this.swiperActive];
            // console.log(this.swiperActive,this.realIndex,this.activeIndex,'this.activeIndex') //切换结束时，告诉我现在是第几个slide
          },
          // transitionStart(){
          //   this.setTranslate(0)
          // }
        },
      },
    };
  }, 
  components: {
    swiper,
    swiperSlide
  },
  created() { 
    this.getBrandNeed();
  },
  computed: {
    ...mapGetters({
      exhibitionId:'getExhibitionId'
    }),
  },
  methods: {
    ...mapActions({
      getBrandChance: 'home/getBrandChance',
    }),
    async getBrandNeed(){
      let opt = {
        ExhibitionId: this.exhibitionId,
        pageSize:40,
        pageIndex:1,
      }
      let data = await this.getBrandChance(opt);
      if (data.items && data.items.length > 0 && data.items.releaseList && data.items.releaseList.length > 0) {
        data.items.releaseList.map(c => {
          if (c.items && c.items.length > 0) {
            c.items.map(d => {
              if (d.photo) {
                d.photo = JSON.parse(d.photo);
              }
            })
          }
        })
      }
      this.ExList = data.items;
      this.selectEX = this.ExList[0];
      // console.log(this.ExList,'data');

    },
    linkToCom(item,index){
      let url = this.$router.resolve({
        path: "/ex-details/" + item.joinId,
        query: {
          exhibitionId: item.exhibitionId,
          compId: item.compId
        }
      });
      window.open(url.href, '_blank');
      // console.log(index,'index')
      // this.swiperActive = index; 
    }
  }
};
</script>
 
<style scoped lang="scss">
.my-card {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  cursor: pointer;
  // margin-top: 25px;
}
.swiper-slide-active{
  img{
    animation: zoomIn .5s ease 0s 1 both;;
  }
}
.swiper-slide {
  height: 120px;
  .my-card-link {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }
  img {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border:1px solid #e6e6e6;
    margin:0 auto;
    position: absolute;
    left:0;
    top:18px;
    right: 0;
    bottom: 0;
  }
  .active{
    img{
    // transform: scale(1.15);
    animation: zoomIn .5s ease 0s 1 both;;
    }
  }
}
.no-msg{
    padding: 0 15px;
    font-size: 14px;
    color: #666;
    text-align: center;
    margin-top: 50px;
}
@keyframes scaleDraw {  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
    0%{
        transform: scale(1);  /*开始为原始大小*/
    }
    100%{
        transform: scale(1.1);
    }
}
@keyframes zoomIn{
  0%{transform:scale(1)}
  100%{transform:scale(1.2)}
}
.card-msg{
  position: relative;
  z-index: 12;
}
.card-msg::before{
  content:"";
  width: 24px;
  height: 24px;
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 8px 0px rgba(149, 152, 155, 0.3);
  box-shadow: 0px 0px 8px 0px rgba(149, 152, 155, 0.3);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: -12px;
  left: 49%;
  z-index: 1;
}
.card-msg::after{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #fff;
    z-index: 2;
}
.card-msg{
  width: 1180px;
  margin:30px  auto 0;
  background-color: #fff;
	box-shadow: 0px 0px 15px 0px 
    rgba(0, 0, 0, 0.1);
  &-li{
    padding: 18px 0;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 10;
  }
  &-com{
    width: 222px;
    height: 232px;
    background: #999;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 11px;
    p{
      color: #fff;
      width: 160px;
      text-align: center;
      line-height: 20px;
    }
    .name{
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
      padding-top: 10px;
    }
    .num{
      padding-top: 6px;
      font-size: 12px;
      span{
        color:#fe781d;
      }
    }
    .msg{
      padding-top: 6px;
      font-size: 12px;
    }

  }
  &-logo{
    width: 78px;
    height: 78px;
    border: solid 1px #f2eded;
    margin-top:30px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  &-needs{
    width: 222px;
    height: 232px;
    background-color: #fff;
    border: solid 1px #f2eded;
    margin-left: 11px;
    padding:10px;
    .one-bot{
        p{
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          color:#666;
          line-height: 14px;
          margin-bottom: 10px;
          .view{
              display: flex;
              align-items: center;
              i{
                margin-right: 2px;
              }
          }
        }
        .one-list-img{
            display: flex;
            flex-wrap: wrap;
            .img{
              width:62px;
              height: 62px;
              margin:0 7px 7px 0;
              img{
                  width: 100%;
                  height: 100%;
              }
            }
            .img:nth-child(3n+3){
              margin-right:0;
            }
        }
        h3{
          font-size: 14px;
          line-height: 24px;
          color:#333;
        }
    }
  }
}
</style> 